import { render, staticRenderFns } from "./AdminDashSchedulesPanel.vue?vue&type=template&id=997a5bf6&scoped=true"
import script from "./AdminDashSchedulesPanel.vue?vue&type=script&lang=js"
export * from "./AdminDashSchedulesPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminDashSchedulesPanel.vue?vue&type=style&index=0&id=997a5bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997a5bf6",
  null
  
)

export default component.exports